import styled from "styled-components";

export const ForSaleBanner = styled.div`
    width: 100%;
    text-align: center;
    margin: 0 auto 20px;
    background: linear-gradient(90deg, #fff4c2 0%, #ffe59e 100%);
    color: #5f4a00;
    border: 1px solid #ffce47;
    border-radius: 8px;
    padding: 12px 18px;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.3px;
    box-shadow: 0 8px 14px rgba(0, 0, 0, 0.12);
`;
